import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * <Container> — max-width wrapper with horizontal padding.
 * Default max-width is 1280px; pass `size="narrow"` for prose-friendly width.
 */
const Container = React.forwardRef(
    ({ className, size = "default", as: Tag = "div", children, ...props }, ref) => {
        const maxWidth =
            size === "narrow"
                ? "max-w-3xl"
                : size === "wide"
                    ? "max-w-screen-2xl"
                    : "max-w-7xl";

        return (
            <Tag
                ref={ref}
                className={cn("mx-auto w-full px-5 sm:px-6 lg:px-8", maxWidth, className)}
                {...props}
            >
                {children}
            </Tag>
        );
    },
);
Container.displayName = "Container";

export { Container };
